import { FieldErrors, FieldError } from 'react-hook-form';

export const getNestedErrorForm = (obj: FieldErrors, path: string): FieldError | null => {
	const keys = path.split('.');
	let currentErrorFields: FieldErrors | null = obj;
	let error: FieldError | null = null;

	keys.forEach((key, index) => {
		if (index === keys.length - 1) {
			error = currentErrorFields && currentErrorFields[key] ? (currentErrorFields[key] as FieldError) : null;
		} else {
			currentErrorFields =
				currentErrorFields && currentErrorFields[key] ? (currentErrorFields[key] as FieldErrors) : null;
		}
	});

	return error;
};
